import { CuiModal, CuiButton } from 'front-lib'

import './FreePremiumMealsModalOutOfStock.scss'

export const FreePremiumMealsModalOutOfStock = ({
  isOpen,
  onCloseClick,
  title,
  description,
  cta
}) => {
  return (
    <CuiModal
      isOpen={isOpen}
      withCloseIcon={true}
      onRequestClose={onCloseClick}
      className="free-premium-meals-modal-out-of-stock">
      <div className="free-premium-meals-modal-out-of-stock-content">
        <span className="title">{title}</span>
        <span className="subtitle">{description}</span>
        <CuiButton
          onClick={onCloseClick}
          size="small"
          fill="outline"
          color="light">
          {cta}
        </CuiButton>
      </div>
    </CuiModal>
  )
}
